import React from "react";

const AddSubTask = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            fill={fill}
            d="M5.889 2H2v23.978a5 5 0 0 0 5 5h20.278v-3.864H9.888a4 4 0 0 1-4-4V2Z"
        />
        <path className="u_fill"
            fill={fill}
            stroke="#4E525F"
            strokeWidth={0.2}
            d="M16.857 5.9h-.1V12.757H9.9v2.486H16.757V22.1h2.486V15.243H26.1v-2.486H19.243V5.9h-2.386Z"
        />
        <path className="u_fill"
            fill={fill}
            d="M28.25 34c2.685 0 4.861-2.19 4.861-4.892 0-2.701-2.176-4.891-4.861-4.891-2.685 0-4.861 2.19-4.861 4.891 0 2.702 2.176 4.892 4.861 4.892Z"
        />
    </svg>
);

export default AddSubTask;